import moment from 'moment-timezone';
/**
 * `YYYY-MM-DDTHH:MI:SSOF:00` 形式の日時文字列を `YYYY/MM/DD` または `YYYY/MM/DD hh:mm:ss` 形式に変換して返す。
 * 変換時のタイムゾーンはユーザのシステム設定に基づく。
 * @param {string} input - `YYYY-MM-DDTHH:MI:SSOF:00` 形式の日時文字列
 * @param {string} type - 変換の種類 (date/datetime)
 * @returns {string} 日時文字列から変換された文字列
 */
const formatDate = (input, type = 'date') => {
  if (!input) return '-';
  const localTimezone = moment.tz.guess();
  const m = moment.tz(input, localTimezone);
  // Invalid datetime format check
  if (!m.isValid()) {
    return '-';
  }
  switch (type) {
    case 'date':
      return m.format('YYYY/MM/DD');
    case 'datetime':
      return m.format('YYYY/MM/DD HH:mm:ss');
    default:
      return '-';
  }
};

export default formatDate;
